import { validatePayload } from '../../../../utils/validate-payload.js';
import { makeAnalyticsAction, } from '../../../analytics/analytics-utils.js';
import { getRangeFacetMetadata, rangeBreadcrumbFacet, } from '../generic/range-facet-analytics-actions.js';
import { rangeFacetSelectionPayloadDefinition } from '../generic/range-facet-validate-payload.js';
//TODO: KIT-2859
export const logNumericFacetBreadcrumb = (payload) => makeAnalyticsAction('analytics/numericFacet/breadcrumb', (client, state) => {
    validatePayload(payload, rangeFacetSelectionPayloadDefinition(payload.selection));
    const metadata = getRangeFacetMetadata(state, payload);
    return client.makeBreadcrumbFacet(metadata);
});
export const numericBreadcrumbFacet = rangeBreadcrumbFacet;
